import { X } from "lucide-react";

import { MinicartIcon } from "~/components/ui/icons/minicart-icon";
import { cn } from "~/lib/ui";

import type { CartReminderToastProps } from "./types";

/**
 * Molecule: the "Ready to Buy?" cart reminder card (SFCC-12333, Figma XD-204
 * "Something is in Your Cart Nudge") — cart icon, two lines of copy, a CTA
 * slot and a close button. Placement and when to show are the caller's.
 */
export function CartReminderToast({
  title,
  message,
  cta,
  closeLabel,
  onClose,
  closeButtonTestId,
  className,
  ...rest
}: CartReminderToastProps) {
  return (
    <div
      className={cn(
        "flex w-[17.5rem] items-start gap-3 rounded-lg border border-neutral-3 bg-white p-3 shadow-lg",
        className,
      )}
      {...rest}
    >
      <MinicartIcon className="mt-0.5 shrink-0 text-accent" />
      <div className="flex min-w-0 flex-1 flex-col gap-2 font-grotesque text-blue-04">
        <div>
          <p className="text-sm font-bold leading-tight">{title}</p>
          <p className="text-xs leading-tight">{message}</p>
        </div>
        {cta}
      </div>
      <button
        type="button"
        aria-label={closeLabel}
        onClick={onClose}
        data-testid={closeButtonTestId}
        className="-mr-1 -mt-1 shrink-0 rounded p-1 text-neutral-11 hover:text-neutral-12 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-accent"
      >
        <X aria-hidden="true" className="h-4 w-4" />
      </button>
    </div>
  );
}
